import { scope } from '@/utils/helper';
import { selectors as subscribeButton } from '../state/subscribe-button';
import root from './root';

export default scope(subscribeButton, root.subscribeButton);
